export default class BaseModel {

    id = null;

    fromJSON(data) {
        for (let key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            if (this.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
    }

    isNew() {
        return !this.id;
    }

}